import Reveal from "./Reveal";

export const JourneyStepper = ({ steps, accent = "gold" }) => {
  const dot = accent === "gold" ? "bg-gold" : "bg-navy";
  const ring = accent === "gold" ? "ring-gold/20" : "ring-navy/15";
  return (
    <div className="relative" data-testid="journey-stepper">
      <div className="absolute left-[27px] top-4 bottom-4 w-px bg-border md:hidden" />
      <div className="hidden md:block">
        <div className="grid" style={{ gridTemplateColumns: `repeat(${steps.length}, minmax(0, 1fr))` }}>
          {steps.map((s, i) => (
            <Reveal key={s.title} delay={i * 90} className="relative px-3 text-center">
              <div className="absolute left-1/2 top-6 hidden h-px w-full -translate-x-0 bg-border md:block" style={{ display: i === steps.length - 1 ? "none" : undefined }} />
              <div className={`relative z-10 mx-auto flex h-12 w-12 items-center justify-center rounded-full ${dot} text-sm font-bold text-white ring-8 ${ring} ring-offset-0`}>
                {i + 1}
              </div>
              <h4 className="mt-5 font-serif text-lg text-navy">{s.title}</h4>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{s.description}</p>
            </Reveal>
          ))}
        </div>
      </div>
      <div className="space-y-6 md:hidden">
        {steps.map((s, i) => (
          <div key={s.title} className="relative flex gap-5">
            <div className={`relative z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-full ${dot} text-base font-bold text-white`}>{i + 1}</div>
            <div className="pt-1">
              <h4 className="font-serif text-lg text-navy">{s.title}</h4>
              <p className="mt-1 text-sm leading-relaxed text-muted-foreground">{s.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default JourneyStepper;
